/**
 * Shared constants for the table/bulk-edit layer.
 * Used by BulkEditModal and validation so "keep current" is treated as valid.
 */

/** Sentinel stored in form state when user clicks "Clear" on a mixed-value field */
export const BULK_EDIT_CLEAR = Symbol('bulkEditClear');

/** Sentinel stored in form state when user wants to keep the current value unchanged */
export const BULK_EDIT_KEEP_CURRENT = Symbol('bulkEditKeepCurrent');
